export default "__VITE_ASSET__18f5b300__"